import type { WatchlistEntityType } from '../services/watchlist'
import type { CVRParticipant, GraphNode } from '../types'

export interface WatchlistEntityRef {
  entityType: WatchlistEntityType
  entityId: string
}

export function participantWatchlistEntity(
  participant: CVRParticipant
): WatchlistEntityRef | null {
  if (participant.enhedstype === 'VIRKSOMHED') {
    if (!participant.cvrNummer) return null
    return { entityType: 'company', entityId: String(participant.cvrNummer) }
  }
  if (!participant.enhedsNummer) return null
  return { entityType: 'person', entityId: String(participant.enhedsNummer) }
}

export function graphNodeWatchlistEntity(node: GraphNode): WatchlistEntityRef | null {
  if (node.kind === 'person' && node.enhedsNummer) {
    return { entityType: 'person', entityId: String(node.enhedsNummer) }
  }
  if (node.cvrNummer) {
    return { entityType: 'company', entityId: String(node.cvrNummer) }
  }
  return null
}

export function companyWatchlistEntity(cvrNummer: string | number): WatchlistEntityRef {
  return { entityType: 'company', entityId: String(cvrNummer) }
}

export function personWatchlistEntity(enhedsNummer: string | number): WatchlistEntityRef {
  return { entityType: 'person', entityId: String(enhedsNummer) }
}
